module.exports = __webpack_public_path__ + "img/icon-RAZ.422d6da4.svg";